import React from "react";

const UserTabbingContext = React.createContext({
  userTabbing: false,
});
export default UserTabbingContext;
